import Editor from "@/components/editor";
export default {
  name: "correspondence-task-preview",
  components: {
    Editor: Editor
  },
  data: function data() {
    return {
      defaultEditorVal: ''
    };
  },
  created: function created() {}
};